<app-text-button
    #tableViewToggle
    [attr.data-qa]="dataQa.tableViewButton"
    [matMenuTriggerFor]="changeTableViewMenu"
    (menuOpened)="menuOpened = true"
    (menuClosed)="menuOpened = false">
    Table view
    <mat-icon [svgIcon]="menuOpened ? 'chevron-up' : 'chevron-down'" />
</app-text-button>
<mat-menu #changeTableViewMenu="matMenu" class="p-3 m-2">
    <div wfeStopClick class="grid gap-10 change-table-view-menu">
        <p>Table View Options</p>
        <mat-button-toggle-group
            name="tableView"
            aria-label="Table View"
            [value]="selected">
            <mat-button-toggle
                [value]="tableView.Document"
                [attr.data-qa]="dataQa.documentViewToggle"
                (change)="changeTableView($event.value)">
                Document View
            </mat-button-toggle>
            <mat-button-toggle
                [value]="tableView.Discrepancy"
                [attr.data-qa]="dataQa.discrepancyViewToggle"
                (change)="changeTableView($event.value)">
                Discrepancy View
            </mat-button-toggle>
        </mat-button-toggle-group>
        <p class="text-xs">{{ description }}</p>
        <mat-divider class="w-full" />
        @if (selected === tableView.Document) {
            <div class="w-full">
                <p class="mb-3">Column Options</p>
                <div class="column-options">
                    @for (item of docOptions; track $index) {
                        <app-checkbox
                            size="small"
                            [disabled]="item.disabled"
                            [checked]="item.checked"
                            [label]="item.label"
                            (checkedChange)="docChanged($event, item.id)" />
                    }
                </div>
                <div class="column-options nested ml-n3 mr-n3 mt-1 p-3">
                    @for (item of nestedDocOptions; track $index) {
                        <app-checkbox
                            size="small"
                            [disabled]="item.disabled"
                            [checked]="item.checked"
                            [label]="item.label"
                            (checkedChange)="
                                nestedDocChanged($event, item.id)
                            " />
                    }
                </div>
            </div>
        } @else {
            <app-discrepancy-view-column-options
                [options]="discOptions"
                (disccOptionsChanged)="discChanged($event)" />
        }
        <app-flat-button
            class="justify-self-end mt-2"
            [dataQa]="dataQa.tableViewMenuClose"
            (clicked)="closeMenu()">
            Close
        </app-flat-button>
    </div>
</mat-menu>
